import React, { useState } from "react";
import {ReactComponent as SVGleft} from '../../assets/arrow-left-3.svg';
import "./style.scss";


const Sidebar = (props) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={"sidebar-container " + (expanded ? ' expand ' : '' ) + ( props.position || 'left'  )}>
            <span className="sidebar-expander" onClick={(e) => {
                e.preventDefault();

                setExpanded(!expanded);
            }}>
                <SVGleft/>
            </span>
            <div className="sidebar-wrapper shadow rounded">
                {props.children}
            </div>
        </div>
    )
}

export default Sidebar;